export enum AccountActionTypes {
  REDIRECT = 'REDIRECT',
  USER_FLOW = 'USER_FLOW',
  DEBUG_MESSAGE = 'DEBUG_MESSAGE',
  NOTIFICATION = 'NOTIFICATION',
}
